export const state = () => ({
  resource: [],
  fetchMeFetched: false
})

export const getters = {
  user: (state) => {
    return state.resource
  },
  isGuest: (state) => {
    return Object.keys(state.resource).length === 0
  }
}

export const mutations = {
  SET_FETCHED (state, status) {
    state.fetchMeFetched = status
  },
  STORE_USER_INFO (state, data) {
    state.resource = data
  }
}

export const actions = {
  logout ({ commit }) {
    const vm = this
    return new Promise((resolve, reject) => {
      vm.$axios({ method: 'put', url: 'user/revoke', baseURL: process.env.BASE_URL_UUID })
        .then((resp) => {
          commit('STORE_USER_INFO', [])
          localStorage.removeItem('access_token')
          window.location.reload()
          resolve(resp)
        }).catch((err) => {
          vm.$toast.error(vm.$t('auth.errorOnLogout'))
          reject(err)
        })
    })
  },
  fetchMe ({ dispatch, commit }, token) {
    const vm = this
    return new Promise((resolve, reject) => {
      if (token) {
        vm.$axios.setToken(token.token, 'Bearer')
      }
      vm.$axios({ url: '/user/me', baseURL: process.env.BASE_URL_UUID })
        .then((response) => {
          commit('STORE_USER_INFO', response.data.data)
          commit('SET_FETCHED', true)
          resolve(response)
        }).catch((err) => {
          commit('SET_FETCHED', true)
          reject(err)
        })
    })
  }
}
